export enum AuthRouterStateKey {
  IS_INVALID_RESET_TOKEN = 'isInvalidResetToken',
  IS_INVALID_ACTIVATE_TOKEN = 'isInvalidActivateToken',
  IS_INVALID_INVITE = 'isInvalidInvite',
  EMAIL = 'email',
  PASSWORD = 'password',
  COMPANY_ID = 'companyId',
}
